export default [
  {
    path: "/earningStructure",
    component: () => import(/* webpackChunkName: "earningStructure" */ "./layout"),

    children: [
      {
        path: "/",
        name: "earningStructure.index",
        component: () => import(/* webpackChunkName: "earningStructure" */ "./all"),
      },
    ],
  },
];
